import React from 'react';
import { CompanyDto } from '@jaam/commons/dtos';

import CompanyItem from '../companyItem/CompanyItem';
interface Iprops {
  compagnies: CompanyDto[];
  activeCompany?: CompanyDto;
  handleClick: (company: CompanyDto) => void;
}

const CompanyList = ({
  compagnies,
  activeCompany,
  handleClick,
}: Iprops): React.ReactElement => {
  return (
    <div>
      {compagnies.map((company: CompanyDto) => (
        <CompanyItem
          key={company.id}
          company={company}
          active={activeCompany?.id === company.id}
          handleClick={handleClick}
        />
      ))}
    </div>
  );
};

CompanyList.defaultProps = {
  activeCompany: {},
};

export default CompanyList;
